import PropTypes from 'prop-types';
import React from 'react';
import { APP_URLS } from '../../utils/appUrls';
import { isExistingSubmission } from '../../utils/helpers';
import { CONTACTS } from '../../utils/imports';

export const CONTACT_COPY_BY_SUBMISSION_TYPE = Object.freeze({
  new: {
    title: 'How to contact us about your application',
    subject: 'application',
  },
  update: {
    title: 'How to contact us about your updated CHAMPVA information',
    subject: 'updated benefits information',
  },
});

const ConfirmationFaq = ({ formData }) => {
  const isUpdate = isExistingSubmission(formData);
  const contactCopy =
    CONTACT_COPY_BY_SUBMISSION_TYPE[isUpdate ? 'update' : 'new'];
  return (
    <>
      <section className="confirmation-faq">
        <h2>What to expect next</h2>
        <div data-testid="1010d-confirmation-apply-faq">
          {isUpdate ? (
            <p data-testid="1010d-confirmation-update-review-time">
              It may take several weeks to review your updated information.
              Don’t submit your documents more than once. This may delay
              processing times.
            </p>
          ) : (
            <p data-testid="1010d-confirmation-new-review-time">
              We typically review applications within 5 business days.
            </p>
          )}
          <p>
            You don’t need to do anything unless we send you a letter asking for
            more information.
          </p>
          <p className="screen-only">
            <va-link
              text="Learn what to do after you apply for CHAMPVA benefits"
              href="/resources/what-to-do-after-applying-for-champva-benefits/"
              external
            />
          </p>
        </div>

        {isUpdate && (
          <div data-testid="1010d-confirmation-update-faq">
            <h3>
              If you need to update information for other CHAMPVA beneficiaries
            </h3>
            <p>You can submit a new form and follow the same steps.</p>
            <p className="screen-only">
              <va-link
                text="Update information for other applicants"
                href={APP_URLS['1010d']}
                external
              />
            </p>
          </div>
        )}
      </section>

      <section className="confirmation-faq">
        <h2 data-testid="1010d-confirmation-contact-title">
          {contactCopy.title}
        </h2>
        <p data-testid="1010d-confirmation-contact-body">
          If you have any questions about your {contactCopy.subject}, call us at{' '}
          <va-telephone contact="8007338387" /> (
          <va-telephone contact={CONTACTS['711']} tty />
          ). We’re here Monday through Friday, 8:00 a.m. to 7:30 p.m.{' '}
          <abbr title="Eastern Time">ET</abbr>.
        </p>

        <p>Or you can ask us questions online through Ask VA.</p>
        <p className="screen-only">
          <va-link
            text="Contact us online through Ask VA"
            href={APP_URLS.askVa}
          />
        </p>
      </section>
    </>
  );
};

ConfirmationFaq.propTypes = {
  formData: PropTypes.object,
};

export default ConfirmationFaq;
